/* eslint typescript-sort-keys/string-enum: "warn", curly: "error" */

export enum RealTimeEvents {
  DatasetVersionPreviewComplete = "DatasetVersionPreviewComplete",
  DeploymentCompleteEvent = "DeploymentCompleteEvent",
}
